import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0156',
    ecrans: ['00-2'],
    params: ['aftcleint',
             'datref']
});
